import { getData } from "./Http/api";

// Motivos de campaña cualitativa. Con soloActivos se devuelven los que se ofrecen al importar.
export const fetchMotivosCualitativos = async (soloActivos = false) => {
  try {
    const response = await getData("/MotivoCualitativoListar");
    return (response?.value || [])
      .map((item) => ({
        idMotivoCualitativo: item.idMotivoCualitativo,
        descripcion: item.descripcion,
        activo: !!item.activo,
      }))
      .filter((m) => !soloActivos || m.activo);
  } catch (ex) {
    console.error("Error cargando Motivos Cualitativos:", ex);
    return [];
  }
};
